import {
  API_ADD_TICKET_MESSAGE,
  API_DELETE_EXTERNAL_TICKET,
  API_DELETE_INTERNAL_TICKET,
  API_DELETE_TICKET_ATTACHMENT,
  API_DELETE_TICKET_STORY,
  API_GET_ALL_MESSAGES_FILTER,
  API_GET_TICKET_CONFIG,
  API_GET_TICKET_DETAILS,
  API_GET_TICKETS_FILTER,
  API_UPDATE_TICKET_STORY,
  API_UPDATE_TICKET_TASK,
} from 'config'
import Api from 'services/api'

export const getTickets = (filterData: Record<string, any>) => {
  return Api.get(API_GET_TICKETS_FILTER, filterData)
}

export const getAllTicketMessages = (ticketId: string, stackNum: number = 1) => {
  return Api.get(API_GET_ALL_MESSAGES_FILTER, {}, { ticketId, stackNum })
}

export const sendTicketMessage = (data: Record<string, any>) => {
  return Api.post(API_ADD_TICKET_MESSAGE, data)
}

export const deleteInternalTicket = (id: number) => {
  return Api.delete(API_DELETE_INTERNAL_TICKET, {}, { id })
}

export const deleteExternalTicket = (id: number) => {
  return Api.delete(API_DELETE_EXTERNAL_TICKET, {}, { id })
}

export const createTicket = (data: Record<string, any>) => {
  return Api.post(API_GET_TICKETS_FILTER, data)
}

export const getConfig = () => {
  return Api.get(API_GET_TICKET_CONFIG)
}

export const getTicketDetails = (ticketId: string) => {
  return Api.get(API_GET_TICKET_DETAILS, {}, { ticketId })
}

export const updateTicketDescription = (gid: string, description: string) => {
  return Api.put(API_UPDATE_TICKET_TASK, { description }, { gid })
}

export const updateTicketComment = (storyGid: string, html: string, createdBy?: string) => {
  return Api.put(API_UPDATE_TICKET_STORY, { html, createdBy }, { storyGid })
}

export const deleteTicketComment = (storyGid: string) => {
  return Api.delete(API_DELETE_TICKET_STORY, {}, { storyGid })
}

export const deleteTicketAttachment = (attachmentGid: string) => {
  return Api.delete(API_DELETE_TICKET_ATTACHMENT, {}, { attachmentGid })
}
